/**
 * Shared editor tab creation — used by the tab bar "+" button and View menu reopen.
 */

import { Actions, DockLocation, type Model } from "flexlayout-react"
import { PANEL_COMPONENTS } from "./layout-model"

/** Stable flexlayout tab id — avoids auto-generated ids like "#3" that break URLs. */
export function editorTabIdFromFileId(fileId: string): string {
  return `tab-editor-${fileId.replace(/[^a-zA-Z0-9._-]+/g, "-")}`
}

/** Create a new untitled editor tab descriptor with a unique id */
function makeNewEditorTab() {
  const uid = Math.random().toString(36).slice(2, 8)
  const fileId = `untitled-${uid}.tex`
  return {
    type: "tab" as const,
    id: editorTabIdFromFileId(fileId),
    component: PANEL_COMPONENTS.CODE_EDITOR,
    name: "untitled.tex",
    config: { fileId },
  }
}

export function addEditorTabToTabset(model: Model, tabsetId: string) {
  model.doAction(
    Actions.addNode(
      makeNewEditorTab(),
      tabsetId,
      DockLocation.CENTER,
      -1,
      true,
    ),
  )
}
